import React from "react";
import { Flex, Typography } from "antd";
import ActionRow from "./ActionRow";
import { TEXT } from "./SkillsBridgerV2.constants";
import { HeaderWrapperStyled, HeaderTitleStyled } from "./SkillsBridgerPageHeader.styles";

const { Text } = Typography;

const SkillsBridgerPageHeader = ({ onGroupSkillsMap, onGroupSkillsProficiency, loading, hasSelection }) => (
  <HeaderWrapperStyled justify="space-between" align="center">

    {/* ── Left: title + description ── */}
    <Flex vertical gap={4} flex={3}>
      <Flex align="center" gap={10}>
        <HeaderTitleStyled level={3}>{TEXT.PAGE_TITLE}</HeaderTitleStyled>
      </Flex>
      <Text type="secondary">{TEXT.PAGE_DESCRIPTION}</Text>
    </Flex>

    {/* ── Right: action rows ── */}
    <Flex vertical gap={8} align="flex-end" flex={2}>
      <ActionRow label={TEXT.ACTION_SKILLS_MAP_LABEL} onClick={onGroupSkillsMap} disabled={loading || !hasSelection}>
        {TEXT.ACTION_SKILLS_MAP_BTN}
      </ActionRow>
      <ActionRow label={TEXT.ACTION_SKILLS_PROFICIENCY_LABEL} onClick={onGroupSkillsProficiency} disabled={loading || !hasSelection}>
        {TEXT.ACTION_SKILLS_PROFICIENCY_BTN}
      </ActionRow>
    </Flex>

  </HeaderWrapperStyled>
);

export default SkillsBridgerPageHeader;
